import React, { Component } from 'react'
import { Form, FormGroup } from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
class EMCheckbox extends Component {

    constructor(...args) {
      super(...args)
      this.state = {}
      
    }

    onFormChange(e) {
        this.props.onChange(e)
    }

    render() {
        let {formData,schema} = this.props
        return(
            <Form>
                <FormGroup>
                    <Checkbox
                        onChange={this.onFormChange.bind(this,(formData?false:true))}
                        checked={formData}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"       
                        label={' '+schema.title}           
                    />
                </FormGroup>
            </Form>    
        )
    }    
}    
export default EMCheckbox


// WEBPACK FOOTER //
// ./src/view/hr/employee/EMCheckbox.js